<div class="option-panels-wrapper">
    <ng-container *ngFor="let column of columns$ | async; let columnIndex = index">
        <div
            class="option-group-column"
            [ngClass]="{
                'option-group-column--mobile': numberOfColumns === 1,
                'two-column': numberOfColumns === 2,
            }">
            <ng-container *ngFor="let vm of vms$ | async | slice: 0 : limit; let vmIndex = index; trackBy: trackByEventId">
                @if (vmIndex % numberOfColumns === columnIndex) {
                    @for (optionGroup of vm.preparedOptionGoups; track trackByOptionGroupId) {
                        <ms-option-panel
                            [optionGroup]="optionGroup"
                            [event]="vm.eventModel"
                            [tracking]="tracking"
                            [trackingModuleType]="trackingModuleType"
                            [showHelp]="true"
                            [showEventName]="true"
                            [showEventTimer]="true"
                            [toggleable]="false"
                            [isLinkToEvent]="pod.enableTitleLink"
                            [showEventChevron]="true"
                            [optionsLimitOverride]="pod.optionsBeforeShowMore"
                            (eventTitleClicked)="trackEventHeaderClick()" />
                    }
                }
            </ng-container>
        </div>
    </ng-container>
</div>
@if (contentRendered && pod.eventsBeforeShowMore && vms$.value.length > pod.eventsBeforeShowMore * numberOfColumns) {
    <ms-top-events-show-more-less-button [currentLength]="limit" [totalLength]="vms$.value.length" (showMoreClicked)="showHideEvents($event)" />
}
@if (contentRendered && !this.pod.hideBottomLink && link && limit >= vms$.value.length) {
    <div class="all-markets-link">
        <ms-item [href]="link.url" [tracking]="undefined" (itemClicked)="trackBottomLink()">
            <span class="title" item-title [innerHtml]="link.text || sitecore.event.ShowMore | msTrust: 'html'"></span>
        </ms-item>
    </div>
}
